import { ComponentProps } from "react";
import { IonButton, IonButtons, IonHeader, IonSearchbar, IonTitle, IonToolbar } from "@ionic/react";

import { translate } from "~utils";

/***** Types *****/
type ModalHeaderProps = {
  /** The title to display in the header */
  title: string;
  /** Callback function when the modal is dismissed */
  onModalDismiss?: () => void;
  /** Callback function when the confirm button is clicked */
  onModalConfirm: () => void;
  /** Optional text for the confirm button, defaults to "Done" */
  confirmButtonText?: string;
  /** Optional flag to disable the confirm button, defaults to false */
  isConfirmTextDisabled?: boolean;
} & ComponentProps<typeof IonSearchbar>;

/**
 * A reusable modal header component with cancel and confirm buttons.
 * Optionally includes a search bar when the onIonInput prop is provided.
 */
export function ModalHeader(props: ModalHeaderProps) {
  const {
    title,
    onModalDismiss,
    onModalConfirm,
    confirmButtonText = translate("LABEL_DONE"),
    isConfirmTextDisabled = false,
    onIonInput,
  } = props;

  return (
    <IonHeader>
      <IonToolbar>
        {onModalDismiss && (
          <IonButtons slot="start">
            <IonButton color="danger" onClick={onModalDismiss}>
              {translate("LABEL_CANCEL")}
            </IonButton>
          </IonButtons>
        )}
        <IonTitle>{title}</IonTitle>
        <IonButtons slot="end">
          <IonButton color="primary" onClick={onModalConfirm} disabled={isConfirmTextDisabled}>
            {confirmButtonText}
          </IonButton>
        </IonButtons>
      </IonToolbar>
      {!!onIonInput && (
        <div css={{ margin: "var(--spacing-sm)" }}>
          <IonSearchbar className="searchbar" onIonInput={onIonInput} showClearButton="always" />
        </div>
      )}
    </IonHeader>
  );
}
